<script lang="ts" setup>
import { IconBoxSeam, IconTruckDelivery, IconMapPin } from '@/icons';
defineProps<{
  units: number;
  donorStore: string;
  receiverStore: string;
}>();
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.header">
      <IconBoxSeam :size="16" :class="$style.headerIcon" />
      <span :class="$style.headerText">{{ units }}</span>
      <span :class="$style.headerText">Units</span>
    </div>
    <div :class="$style.row">
      <div :class="$style.pill">
        <IconTruckDelivery :size="16" :class="$style.pillIcon" />
        <span :class="$style.pillText">{{ donorStore }}</span>
      </div>
      <div :class="$style.pill">
        <IconMapPin :size="16" :class="$style.pillIcon" />
        <span :class="$style.pillText">{{ receiverStore }}</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  border: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
  border-radius: 10px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
}

.header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 8px;
  border-bottom: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
}

.headerIcon {
  color: var(--ui2-content-tertiary, #978f91);
  flex-shrink: 0;
}

.headerText {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: var(--ui2-content-tertiary, #978f91);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row {
  display: flex;
  gap: 4px;
}

.pill {
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 6px;
  background: var(--ui2-background-tone-3, #fafafa);
}

.pillIcon {
  color: var(--ui2-content-tertiary, #978f91);
  flex-shrink: 0;
}

.pillText {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  color: var(--ui2-content-tertiary, #978f91);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
